import * as React from "react";
import {Grid} from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Catalogo from "../../components/Catalogo";
import { DispositivosForm }  from "../../Catalogos";
import { GetRoles } from "../../herramientas/JWT";
function DispositivosPage() {
  if(!GetRoles().includes("root",))
    window.history.back();
  return (
    <SiteWrapper>
        <Grid.Col sm={12} lg={12}> 
          <Catalogo
            titulo="Dispositivos"
            tamanio="80%"
            FCtlogo= { DispositivosForm }
            catalogo= "dispositivos"
            columnas= {
              [
                { columna: "id", label:"ID" },
                { columna: "nombre", label:"NOMBRE" },
                { columna: "identificador", label:"IDENTIFICADOR" },
                { columna: "proveedor.nombre", label:"PROVEEDOR" },
                { columna: "grupo", label:"GRUPO" },
              ]
            }
          />
        </Grid.Col>
    </SiteWrapper>
  );
}
export default DispositivosPage;
